import { reactPosts } from '../data/blog/react';
import { javascriptPosts } from '../data/blog/javascript';
import { typescriptPosts } from '../data/blog/typescript';
import { nodejsPosts } from '../data/blog/nodejs';
import { databasePosts } from '../data/blog/database';
import { cloudPosts } from '../data/blog/cloud';
import { devopsPosts } from '../data/blog/devops';
import { securityPosts } from '../data/blog/security';
import { uiuxPosts } from '../data/blog/uiux';
import { aiPosts } from '../data/blog/ai';
import { architecturePosts } from '../data/blog/architecture';
import { performancePosts } from '../data/blog/performance';

export const blogPosts = [
  ...reactPosts,
  ...javascriptPosts,
  ...typescriptPosts,
  ...nodejsPosts,
  ...databasePosts,
  ...cloudPosts,
  ...devopsPosts,
  ...securityPosts,
  ...uiuxPosts,
  ...aiPosts,
  ...architecturePosts,
  ...performancePosts
];
